'use client';
import { useQueryClient as useQueryClient$1 } from '@tanstack/react-query';
import { useContext } from 'react';
import { QraftContext } from '../QraftContext.js';

/**
 * Get the QueryClient from the QraftContext or the provided QueryClient argument.
 * @param qraftOptions if `queryClient` is not provided, will be taken from context
 * @param queryClient If not provided, will be taken this instance
 */ function useQueryClient(qraftOptions, queryClient) {
    const queryClientByContext = useContext(qraftOptions?.context ?? QraftContext)?.queryClient;
    return useQueryClient$1(queryClient ?? queryClientByContext);
}

export { useQueryClient };
//# sourceMappingURL=useQueryClient.js.map
